const Data = ( {symbol, allBetAmount, allWonAmount, allBets} ) => {

  return (
    <section className="data">
    <h2>Overall data</h2>
    <div className="grid">
      <div>
        <h4>{allBetAmount} <span>{symbol}</span></h4>
        <p>Bet amount</p>
      </div>
      <div>
        <h4>{allWonAmount} <span>{symbol}</span></h4>
        <p>Won amount</p>
      </div>
      <div>
        <h4>{allBets}</h4>
        <p>Bets</p>
      </div>
    </div>
  </section>
  );
} 

export default Data